// src/components/VerificationBanner.tsx
import React, { useContext, useState } from 'react';
import { useUser } from '../../contextManager/user.context';
import { AxiosContext } from '../../contextManager/axios.context';
import { useToast } from '../../contextManager/toast.context';
import { endpoints, baseURL } from '../../constants/endpoints';
import { styled } from '../../styles/stitches.config';

/**
 * Displays a banner prompting unverified users to check their email.
 * Includes a "Resend" button. Drop this into any authenticated layout.
 */

export const CustomDiv = styled('div', {
    width: '100%',
    padding: '0.75rem 1rem',
    backgroundColor: '$yellow2',
    border: '1px solid $yellow10',
    borderRadius: '0.5rem', // A standard radius often looks better than a full pill when at 100% width
    marginBottom: '1rem',

    // borderBottom: '1px solid #f59e0b',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.75rem',
    fontSize: '0.875rem',
    color: '$yellow11',
    flexWrap: 'wrap',
})
export const VerificationBanner: React.FC = () => {
  const { userDetails } = useUser();
  const axios = useContext(AxiosContext);
  const { addToast } = useToast();
  const [sending, setSending] = useState(false);

  // Don't render if user is verified or not logged in
  if (!userDetails || userDetails.email_verified) return null;

  const handleResend = async () => {
    setSending(true);
    try {
      await axios.post(`${baseURL}/verify/resend`);
      addToast({ variant: 'success', title: 'Verification email sent! Check your inbox.' });
    } catch {
      addToast({ variant: 'error', title: 'Failed to send verification email. Try again later.' });
    } finally {
      setSending(false);
    }
  };


  return (
    <CustomDiv
    >
      {/* <span> */}
        Please verify your email address. Check your inbox for a verification link.
      {/* </span> */}
      <button
        onClick={handleResend}
        disabled={sending}
        style={{
          all: 'unset',
          cursor: sending ? 'not-allowed' : 'pointer',
          fontWeight: 600,
          textDecoration: 'underline',
          opacity: sending ? 0.6 : 1,
        }}
      >
        {sending ? 'Sending…' : 'Resend email'}
      </button>
    </CustomDiv>
  );
};